<cbs-product-content>
    <cbs-documents></cbs-documents>
</cbs-product-content>
